import { Platforms } from "../../../../../utils/constants";
import { IntegrationsMapping } from "../../../integrations/IntegrationsMapping";
import {
  getMacOSName,
  getWindowsOSName,
} from "../../components/entitiesCharts/hostChart/osVersionDistribution/osVersionHelpers";
import { getServerOSVersion } from "../../utils";
import { filterName } from "../utils";

export const applyServerFilters = (entities, appliedFilters) => {
  let filteredEntities = [...entities];

  // Server Type
  if (
    filterName.SERVER_TYPE in appliedFilters &&
    Object.keys(appliedFilters[filterName.SERVER_TYPE]).length > 0
  ) {
    const checkedTypes = Object.keys(
      appliedFilters[filterName.SERVER_TYPE]
    ).filter((type) => appliedFilters[filterName.SERVER_TYPE][type]);
    if (checkedTypes.length > 0) {
      filteredEntities = filteredEntities.filter(
        (entity) =>
          checkedTypes.includes(entity.aws_service) ||
          (checkedTypes.includes(IntegrationsMapping.cloudflare.displayName) &&
            entity?.cloudflare_data?.server_type) ||
          checkedTypes.includes(entity.azure_vm_data?.resource_type)
      );
    }
  }

  // Server OS
  if (
    filterName.SERVER_OS in appliedFilters &&
    Object.keys(appliedFilters[filterName.SERVER_OS]).length > 0
  ) {
    const checkedOSs = Object.keys(appliedFilters[filterName.SERVER_OS]).filter(
      (key) => appliedFilters[filterName.SERVER_OS][key]
    );
    if (checkedOSs.length > 0) {
      filteredEntities = filteredEntities.filter((entity) =>
        checkedOSs.includes(entity.platform)
      );
    }
  }

  // Server OS Version
  if (
    filterName.SERVER_OS_VERSION in appliedFilters &&
    Object.keys(appliedFilters[filterName.SERVER_OS_VERSION]).length > 0
  ) {
    const checkedOSVersions = Object.keys(
      appliedFilters[filterName.SERVER_OS_VERSION]
    ).filter((key) => appliedFilters[filterName.SERVER_OS_VERSION][key]);
    if (checkedOSVersions.length > 0) {
      filteredEntities = filteredEntities.filter((entity) => {
        const osVersion = getServerOSVersion(entity);
        if (!osVersion || osVersion === "None") return false;
        const platform = entity.platform;
        let displayVersion;
        if (platform === Platforms.WINDOWS) {
          const formatted = getWindowsOSName(osVersion);
          displayVersion = formatted === "Windows" ? osVersion : formatted;
        } else if (platform === Platforms.MACOS) {
          const formatted = getMacOSName(osVersion);
          displayVersion =
            formatted === "" || formatted === "MacOS" ? osVersion : formatted;
        } else {
          displayVersion = osVersion;
        }
        return checkedOSVersions.includes(displayVersion);
      });
    }
  }

  // Server Image
  if (
    filterName.SERVER_IMAGE in appliedFilters &&
    Object.keys(appliedFilters[filterName.SERVER_IMAGE]).length > 0
  ) {
    const checkedOSVersions = Object.keys(
      appliedFilters[filterName.SERVER_IMAGE]
    ).filter((key) => appliedFilters[filterName.SERVER_IMAGE][key]);
    if (checkedOSVersions.length > 0) {
      filteredEntities = filteredEntities.filter((entity) =>
        checkedOSVersions.includes(entity?.aws_data?.image_description)
      );
    }
  }

  // Internet Exposure
  if (
    filterName.INTERNET_EXPOSURE in appliedFilters &&
    Object.keys(appliedFilters[filterName.INTERNET_EXPOSURE]).length > 0
  ) {
    const checkedExposures = Object.keys(
      appliedFilters[filterName.INTERNET_EXPOSURE]
    ).filter((key) => appliedFilters[filterName.INTERNET_EXPOSURE][key]);
    if (checkedExposures.length > 0) {
      filteredEntities = filteredEntities.filter((entity) => {
        const entityStatus = entity?.is_internet_facing
          ? "Exposed"
          : "Not Exposed";
        return checkedExposures.includes(entityStatus);
      });
    }
  }

  if (
    filterName.SECURITY_GROUPS in appliedFilters &&
    Object.keys(appliedFilters[filterName.SECURITY_GROUPS]).length > 0
  ) {
    const checkedSecurityGroups = Object.keys(
      appliedFilters[filterName.SECURITY_GROUPS]
    ).filter((key) => appliedFilters[filterName.SECURITY_GROUPS][key]);
    if (checkedSecurityGroups.length > 0) {
      filteredEntities = filteredEntities.filter((entity) => {
        const entitySecurityGroups = entity?.aws_data?.security_groups || [];
        return entitySecurityGroups.some((security_group) =>
          checkedSecurityGroups.includes(security_group?.name)
        );
      });
    }
  }

  // CVE severity
  // Implemented in the sharedFiltersLogic

  entities.length = 0;
  for (let i = 0; i < filteredEntities.length; i++) {
    entities[i] = filteredEntities[i];
  }
};
